<mat-toolbar>
<div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>
    <div class="copyright"><p>Copyright {{currentYear}} Day Translations, Inc | All Rights Reserved</p></div>
    </div> 
</mat-toolbar>
